import Model, { attr } from '@ember-data/model';
import type { TImportTableName } from 'volta/models/types/data-import';
import type {
  RelationshipsWithData,
  ResourceIdentifierObject,
  SingleResourceDoc
} from 'volta/utils/api/jsonapi-types';

export interface IResourceName {
  singular: string;
  plural: string;
  table?: TImportTableName;
}

export const DefaultResourceName: IResourceName = {
  singular: 'item',
  plural: 'items'
};

export default class BaseModel extends Model {
  @attr('number', { defaultValue: 1 })
  declare version: number;

  @attr('date', { defaultValue: () => new Date() })
  declare createdAt: Date;

  @attr('date', { defaultValue: () => new Date() })
  declare updatedAt: Date;

  toJSON(options?: { includeId?: boolean | undefined }) {
    const serialized = this.serialize(options) as SingleResourceDoc;
    const { data } = serialized;
    const json = data?.attributes ?? {};
    if (data?.relationships) {
      Object.keys(data?.relationships).forEach((k: string) => {
        const linkData = (data?.relationships?.[k] as RelationshipsWithData)
          .data as ResourceIdentifierObject;
        if (linkData?.id != null) {
          json[k] = {
            id: linkData.id
          };
        } else if (Array.isArray(linkData)) {
          json[k] = linkData.filter((item) => item.id != null).map((item) => ({ id: item.id }));
        }
      });
    }

    return { ...json, id: this.id };
  }
}
